import { NavLink } from "react-router-dom";
import { NAV_LINKS } from "./links";

export const MobileMenu = ({ onNavigate }) => (
    <div className="md:hidden bg-white/90 backdrop-blur-xl border-t border-black/10 px-5 py-5 flex flex-col gap-4">
        {NAV_LINKS.map((l) => (
            <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => {
                    onNavigate();
                    if (l.to === "/") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                }}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                    `font-body text-sm text-left ${
                        isActive ? "text-black" : "text-black/80"
                    }`
                }
            >
                {l.label}
            </NavLink>
        ))}
        <NavLink
            to="/contact"
            onClick={onNavigate}
            data-testid="nav-mobile-start-briefing"
            className="font-body text-sm bg-black text-white px-5 py-3 rounded-full text-center"
        >
            CONTACT US
        </NavLink>
    </div>
);
